import React from 'react';

function BelgiumIcon() {
    return (
        <svg
         width="18"
         height="18"
         viewBox="0 0 24 24"
         transform="translate(0, 4)"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_13_6)">
                <circle
                cx="12"
                cy="12"
                r="11.25"
                fill="#fff"
                stroke="#000"
                stroke-width="0.027"
                />
                <path
                d="m 6.5 7.63 c 0 -2.474 2.75 -4.015 4.95 -2.09 2.197 -1.924 4.95 -0.384 4.95 2.09 0 2.474 -3.57 3.302 -4.95 6.872 -1.372 -3.57 -4.95 -4.398 -4.95 -6.872 z"
                fill="#fff203"
                stroke="#b8b8ba"
                stroke-linejoin="round"
                stroke-linecap="round"
                stroke-width="0.823"
                />
                <g fill="#0a00be">
                    <path d="m 11.01 16.61 c -0.785 -2.675 -2.9 -6.086 -6.6 -6.768 -2.178 -0.402 -4.6 1.747 -3.305 4.716 0.673 1.541 2.617 2.052 4.347 1.733 1.353 -0.251 3.3 -0.63 4.633 0.7 0.637 0.656 1.113 0.248 0.927 -0.413 z" />
                    <path d="m 12.21 16.61 c 0.785 -2.675 2.9 -6.086 6.6 -6.768 2.178 -0.402 4.6 1.747 3.305 4.716 -0.673 1.541 -2.617 2.052 -4.347 1.733 -1.353 -0.251 -3.3 -0.63 -4.633 0.7 -0.637 0.656 -1.113 0.248 -0.927 -0.413 z" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_13_6">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default BelgiumIcon;
